import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import { getPeriodLabel } from "../../../../../Components/Filters/DropdownDateBlock/periodLabel"
import { getCalculatedPeriod } from "../../../../../Utils/utils"

import styles from "./PeriodLabel.module.less"

const PeriodLabel = () => {
  const { t } = useTranslation()
  const filters = useSelector((state) => state.health.filters)
  const lang = useSelector((state) => state.auth?.userInfo?.language) || "en"

  const label = getPeriodLabel({
    range: getCalculatedPeriod(filters?.period),
    presetId: filters?.__preset_period,
    lang,
    t
  })

  return <span className={styles.label}>{label}</span>
}

export default PeriodLabel
